export const SystemSettingKeys = {
  NCAP_INTEGRATION_ENABLED: 'NCAP_INTEGRATION_ENABLED',
} as const;

export type SystemSettingKey = typeof SystemSettingKeys[keyof typeof SystemSettingKeys];

export interface ISystemSetting {
  _id?: string;
  key: string;
  value: any;
  description?: string;
  updatedBy?: any;
  updatedAt?: string;
  createdAt?: string;
}

class SystemSetting implements ISystemSetting {
  _id?: string;
  key: string;
  value: any;
  description?: string;
  updatedBy?: any;
  updatedAt?: string;
  createdAt?: string;

  constructor(data: ISystemSetting) {
    this._id = data._id;
    this.key = data.key;
    this.value = data.value;
    this.description = data.description;
    this.updatedBy = data.updatedBy;
    this.updatedAt = data.updatedAt;
    this.createdAt = data.createdAt;
  }

  toObject(): ISystemSetting {
    return {
      _id: this._id,
      key: this.key,
      value: this.value,
      description: this.description,
      updatedBy: this.updatedBy,
      updatedAt: this.updatedAt,
      createdAt: this.createdAt,
    };
  }

  fromDataModel(data: any): SystemSetting {
    return new SystemSetting(data);
  }
}

export default SystemSetting;

